export default "__VITE_ASSET__Z3a8ptxb__"